import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { IZone } from "interfaces/zone.interface";

import { CreateUserForm } from "./forms/CreateUserForm";

type UserCreatePageProps = {
  zones: IZone[];
};

export function UserCreatePage({ zones }: UserCreatePageProps) {
  const { authUser } = useAuthenticatedUser();

  return <CreateUserForm zones={zones} authUser={authUser} />;
}
